<div class="modal-dialog modal-dialog-centered modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" i18n>Detalhes do Contrato</h5>
      <button type="button" (click)="onClose()"
        class="btn btn-fade-secondary btn-icon-block" data-dismiss="modal"
        aria-label="Close">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="modal-body label">
      <div class="container">
        <div class="row">
          <div class="col-4">
            <app-input type="text" [isLabel]="true" label="Código do Contrato"
              [textValue]="contract && contract.code">
            </app-input>
          </div>
          <div class="col-4">
            <app-input type="text" [isLabel]="true" i18n-label="@@"
              label="Nome do Contrato"
              [textValue]="contract.name">
            </app-input>
          </div>
          <div class="col-4">
            <label i18n><strong>Status:</strong></label>
            <div [ngSwitch]="contract?.status">
              <span *ngSwitchCase="'expired'" class="badge"
                style="background-color: #FF0000; color: #FFFFFF"
                i18n>Vencido</span>
              <span *ngSwitchCase="'closed'" class="badge"
                style="background-color: #808080; color: #FFFFFF"
                i18n>Fechado</span>
              <span *ngSwitchCase="'enabled'" class="badge"
                style="background-color: #008000; color: #FFFFFF"
                i18n>Ativo</span>
              <span *ngSwitchCase="'test'" class="badge"
                style="background-color: #FFFF00; color: #000000"
                i18n>Em Teste</span>
              <span *ngSwitchCase="'history'" class="badge"
                style="background-color: #0000FF; color: #FFFFFF"
                i18n>Histórico</span>
              <span *ngSwitchDefault class="badge badge-fade-secondary">{{
                contract?.status }}</span>
            </div>
          </div>
          <div class="col-4">
            <app-input type="text" [isLabel]="true" i18n-label="@@"
              label="Código Interno"
              [textValue]="contract && contract.internalCode">
            </app-input>
          </div>
          <div class="col-4">
            <app-input type="text" [isLabel]="true" i18n-label="@@"
              label="Empresa Reponsável"></app-input>
            <div class="badge badge-secondary mr-1">
              {{contract.company?.name ||
              getCompanyName(contract.ownerCompanyId)}}
            </div>
          </div>
          <div class="col-4">
            <app-input type="text" [isLabel]="true"
              label="Empresas"></app-input>
            <div *ngFor="let company of contract?.companies"
              class="badge badge-secondary mr-1">
              {{company.name}}
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12">
            <app-input type="text" [isLabel]="true"
              label="Período Vigência"></app-input>
            <fieldset>
              <div class="row">
                <div class="col-12 col-md-3">
                  <label class="required" i18n>Data Inicial</label>
                  <div class="input-group input-group--adjust">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="material-icons">date_range</i>
                      </div>
                    </div>
                    <p>&nbsp;&nbsp;{{ contract?.startsAt | moment: 'L LTS'
                      }}</p>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <label i18n>Data Final</label>
                  <div class="input-group input-group--adjust">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="material-icons">date_range</i>
                      </div>
                    </div>
                    <p>&nbsp;&nbsp;{{ contract?.endsAt | moment: 'L LTS'
                      }}</p>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12">
            <app-input type="text" [isLabel]="true"
              label="Ambientes"></app-input>
            <div *ngIf="contract.enabled?.ecs"
              class="badge badge-secondary mr-1">
              ECS
            </div>
            <div *ngIf="contract.enabled?.bequest"
              class="badge badge-secondary mr-1">
              Legado
            </div>
          </div>
        </div>
        <div class="row mb-4" *ngIf="user?.superUser || gb.isOn('ECS-5791')">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12">
            <app-input type="text" [isLabel]="true"
              label="Interface"></app-input>
            <div *ngIf="contract.enabled?.omnia"
              class="badge badge-secondary mr-1">
              Omnia
            </div>
            <div *ngIf="contract.enabled?.initus"
              class="badge badge-secondary mr-1">
              Initus
            </div>
            <div *ngIf="contract.enabled?.initusTraffic"
              class="badge badge-secondary mr-1">
              Initus Traffic
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12">
            <app-input type="text" [isLabel]="true"
              label="Módulos"></app-input>
            <div class="card-featured my-3">
              <div class="button d-flex justify-content-between">
                <h5><strong>eCS</strong></h5>
                <button
                  class="btn text-secondary btn-icon-block"
                  (click)="openOrCloseEcsModules()">
                  <i class="material-icons"
                    *ngIf="ecsModules.open">unfold_less</i>
                  <i class="material-icons"
                    *ngIf="!ecsModules.open">unfold_more</i>
                </button>
              </div>
              <div class="content" *ngIf="ecsModules.open">
                <div *ngFor="let module of contract?.modules"
                  class="badge badge-secondary mr-1">
                  {{getModuleI18n(module)}}
                </div>
              </div>
            </div>
            <div class="card-featured mb-3">
              <div class="button d-flex justify-content-between">
                <h5><strong>Legado</strong></h5>
                <button
                  class="btn text-secondary btn-icon-block"
                  (click)="openOrCloseBequestModules()">
                  <i class="material-icons"
                    *ngIf="bequestModules.open">unfold_less</i>
                  <i class="material-icons"
                    *ngIf="!bequestModules.open">unfold_more</i>
                </button>
              </div>
              <div class="content" *ngIf="bequestModules.open">
                <div *ngFor="let module of contract?.modulesBequest"
                  class="badge badge-secondary mr-1">
                  <!-- {{getModuleI18n(module)}} -->
                  {{ getModulesBequest(module) }}
                </div>
                <p class="mb-0" *ngIf="!contract?.modulesBequest">
                  Nenhum módulo cadastrado.
                </p>
                <hr>
                <p><strong>URL:</strong> {{ contract?.bequestUrl ||'-' }}</p>
              </div>
            </div>
          </div>
        </div>
        <section>
          <div id="limit">
            <div class="table-responsive table-hover table-block mb-1">
              <div class="d-flex flex-row justify-content-between"
                style="cursor: pointer;">
                <div class="col mt-3" style="font-size: 20px;"
                  (click)="unfoldMoreLimit()">
                  <h5 class="mb-3" i18n><strong>Quantidade Limite
                    </strong>:</h5>
                </div>
                <div class="p-3">
                  <button type="button"
                    class="btn text-secondary btn-icon-block"
                    (click)="unfoldMoreLimit()">
                    <i class="material-icons"
                      *ngIf="typeUnfoldLimit === 'less'; else elseBlockTable1">unfold_less</i>
                    <ng-template #elseBlockTable1>
                      <i class="material-icons">unfold_more</i>
                    </ng-template>
                  </button>
                </div>
              </div>
              <div *ngIf="typeUnfoldLimit === 'more'" class="limited-height">
                <div class="card card-body">
                  <div class="row">
                    <div class="col-4">
                      <app-input type="text" [isLabel]="true" i18n-label="@@"
                        label="Equipamento(s)"
                        [textValue]="contract.limits?.equipments"></app-input>
                    </div>
                    <div class="col-4">
                      <app-input type="text" [isLabel]="true" i18n-label="@@"
                        label="Ponto(s)"
                        [textValue]="contract.limits?.spots"></app-input>
                    </div>
                    <div class="col-4">
                      <app-input type="text" [isLabel]="true" i18n-label="@@"
                        label="Faixa(s)"
                        [textValue]="contract.limits?.lanes"></app-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!gb.isOn('ECS-4075')">
            <div [id]="'speed'">
              <div class="table-responsive table-hover table-block mb-1">
                <div class="d-flex flex-row justify-content-between"
                  style="cursor: pointer;">
                  <div class="col mt-3" style="font-size: 20px;"
                    (click)="unfoldMoreSpeed()">
                    <h5 class="mb-3" i18n><strong>Cálculos de Velocidade
                      </strong>:</h5>
                  </div>
                  <div class="p-3">
                    <button type="button"
                      class="btn text-secondary btn-icon-block"
                      (click)="unfoldMoreSpeed()">
                      <i class="material-icons"
                        *ngIf="typeUnfoldSpeed === 'less'; else elseBlockTable2">unfold_less</i>
                      <ng-template #elseBlockTable2>
                        <i class="material-icons">unfold_more</i>
                      </ng-template>
                    </button>
                  </div>
                </div>
                <div *ngIf="typeUnfoldSpeed === 'more'"
                  class="limited-height">
                  <div class="card card-body">
                    <div class="form-group">
                      <div class="row"
                        *ngFor="let itemSpeed of contract.speedCalculations">
                        <div class="col-6">
                          <app-input type="text" [isLabel]="true"
                            i18n-label="@@" label="Enquadramento"
                            [textValue]="getRegulationName(itemSpeed.regulationId)"></app-input>
                        </div>
                        <div class="col-3">
                          <app-input type="text" [isLabel]="true"
                            i18n-label="@@" label="Fórmula Inicial"
                            [textValue]="itemSpeed.initialSpeedFormula"></app-input>
                        </div>
                        <div class="col-3">
                          <app-input type="text" [isLabel]="true"
                            i18n-label="@@" label="Fórmula Final"
                            [textValue]="itemSpeed.finalSpeedFormula"></app-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="contract.id" [id]="'template'">
            <div class="table-responsive table-hover table-block mb-1">
              <div class="d-flex flex-row justify-content-between"
                style="cursor: pointer;">
                <div class="col mt-3" style="font-size: 20px;"
                  (click)="unfoldMoreTemplate()">
                  <h5 class="mb-3" i18n><strong>Templates AIT </strong>:</h5>
                </div>
                <div class="p-3">
                  <button type="button"
                    class="btn text-secondary btn-icon-block"
                    (click)="unfoldMoreTemplate()">
                    <i class="material-icons"
                      *ngIf="typeUnfoldTemplate === 'less'; else elseBlockTable3">unfold_less</i>
                    <ng-template #elseBlockTable3>
                      <i class="material-icons">unfold_more</i>
                    </ng-template>
                  </button>
                </div>
              </div>
              <div *ngIf="typeUnfoldTemplate === 'more'"
                class="limited-height">
                <div class="card card-body">
                  <div class="form-group">
                    <div class="row"
                      *ngFor="let itemTemplate of contract.aitTemplates">
                      <div class="col-6">
                        <app-input type="text" [isLabel]="true"
                          i18n-label="@@"
                          label="Enquadramento"></app-input>
                        <p
                          *ngFor="let regulationId of itemTemplate.regulationIds">
                          {{getRegulationName(regulationId)}}
                        </p>
                      </div>
                      <div class="col-4">
                        <app-input type="text" [isLabel]="true"
                          i18n-label="@@"
                          label="Template"
                          [textValue]="itemTemplate.templateId"></app-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div [id]="'additional'">
            <div class="table-responsive table-hover table-block mb-1">
              <div class="d-flex flex-row justify-content-between"
                style="cursor: pointer;">
                <div class="col mt-3" style="font-size: 20px;"
                  (click)="unfoldMoreAdditional()">
                  <h5 class="mb-3" i18n><strong>Campos Adicionais
                    </strong>:</h5>
                </div>
                <div class="p-3">
                  <button type="button"
                    class="btn text-secondary btn-icon-block"
                    (click)="unfoldMoreAdditional()">
                    <i class="material-icons"
                      *ngIf="typeUnfoldAdditional === 'less'; else elseBlockTable4">unfold_less</i>
                    <ng-template #elseBlockTable4>
                      <i class="material-icons">unfold_more</i>
                    </ng-template>
                  </button>
                </div>
              </div>
              <div *ngIf="typeUnfoldAdditional === 'more'"
                class="limited-height">
                <div class="card card-body">
                  <div class="form-group">
                    <div class="row"
                      *ngFor="let itemExtra of contract.extraData">
                      <div class="col-6">
                        <app-input type="text" [isLabel]="true"
                          i18n-label="@@"
                          label="Nome"
                          [textValue]="itemExtra.title"></app-input>
                      </div>
                      <div class="col-6">
                        <app-input type="text" [isLabel]="true"
                          i18n-label="@@"
                          label="Valor"
                          [textValue]="itemExtra.value"></app-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
